import {css, Global} from '@emotion/react';
import {useBreakpointUp} from '@travel-frontend/core';

import {fontStyles} from '@/styles';

import 'normalize.css';

/**
 * Without this the CSS is not loaded in development mode.
 * This could also be fixed by excluding the swiper package from pre-bundling in the vite.config
 * but this will significantly increase module load count locally (~100 more).
 * In order to keep this count low we side-load the CSS files in development mode.
 * This will not increase the size of the final production bundle.
 */
if (import.meta.env.MODE === 'development') {
  // eslint-disable-next-line unicorn/prefer-top-level-await -- not working for target environment (browser versions in vite.config)
  (async () => {
    // @ts-expect-error ...
    await import('swiper/css');
    // @ts-expect-error ...
    await import('swiper/css/navigation');
    // @ts-expect-error ...
    await import('swiper/css/pagination');
    // @ts-expect-error ...
    await import('swiper/css/effect-fade');
  })();
}

export const GlobalStyles = () => {
  const xlUp = useBreakpointUp('xl');

  return (
    <Global
      styles={(theme) => css`
        ${fontStyles}

        // This one also comes from the google fonts page.
        // Look at the documentation on how to embed the google fonts.
        // Usually they show you how to use the font in combination with a specific class,
        // but since we use one font everywhere I guess this makes sense to apply just overall elements.
        * {
          font-optical-sizing: auto;
          font-variation-settings: 'wdth' 100;
        }

        h1,
        h2,
        h3,
        h4 {
          margin: 0;
        }

        :root {
          --layout-container-padding: ${xlUp ? '1rem' : '0.5rem'};
          font-family: ${theme.fontFamily};
        }

        :focus-visible {
          outline: ${theme.colors.focusState} dashed 2px;
          outline-offset: 2px;
        }

        /** small position adjustments for the tanstack-query devtools button */
        .tsqd-open-btn-container {
          bottom: 14px !important;
          ${theme.respondTo(
            'md',
            css`
              left: 75px !important;
              bottom: 20px !important;
            `
          )}
        }

        // Override LiveChat styles
        #chat-widget-container {
          z-index: 2 !important;
        }
      `}
    />
  );
};
